import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  createApi,
  fetchBaseQuery,
} from '@reduxjs/toolkit/query/react'
import { clearToken, getToken } from '../config/session'

const UPLOAD_ENDPOINTS = ['uploadFiles']

const getBaseUrl = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL
  }
  return process.env.NODE_ENV === 'development'
    ? 'http://localhost:8089'
    : 'https://tntt.nuvuonghoabinh.com'
}

const BASE_URL = getBaseUrl()

const rawBaseQuery = fetchBaseQuery({
  baseUrl: BASE_URL,
  prepareHeaders: (headers, { endpoint }) => {
    if (!UPLOAD_ENDPOINTS.includes(endpoint)) {
      headers.set('Content-Type', 'application/json')
    }
    const token = getToken()
    if (token) {
      headers.set('Authorization', `Bearer ${token}`)
    } else if (process.env.NODE_ENV === 'development') {
      headers.set('Authorization', 'Bearer dev-token')
    }
    return headers
  },
})

const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
  args,
  api,
  extraOptions
) => {
  const result = await rawBaseQuery(args, api, extraOptions)
  if (result.error && result.error.status === 401) {
    clearToken()
    if (window.location.pathname !== '/') {
      window.location.href = '/'
    }
  }
  return result
}

export const api = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: ['MyStudents'],
  endpoints: () => ({}),
})
